export const getRobotPlatform = (serialNumber) => {
    if (!serialNumber) {
        return 'unknown';
    }

    // Temi serials are currently 11 numeric digits
    if (/^\d{11}$/.test(serialNumber)) {
        return 'temi';
    }

    // CarryBot serials currently start with K
    if (/^K/i.test(serialNumber)) {
        return 'carrybot';
    }

    return 'unknown';
};

export const getRobotCapabilities = (serialNumber) => {
    const platform = getRobotPlatform(serialNumber);

    return {
        platform,
        supportsMap: platform !== 'carrybot',
    };
};